module.exports = __webpack_public_path__ + "img/main-logo.3f344b02.svg";